const convertationDateList = ['DOCUMENT_DATE', 'TX_DATE'];
export default convertationDateList;